// action constants
import Vue from 'vue'
import { StoreMutations } from './mutations';
import SwiftSpaceRepository from '../../../../api/SwiftSpaceRepository';

export const StoreActions = {
    search: 'search',
    create: 'create',
    update: 'update',
    clearState:'clearState'
};

export const actions = {
    [StoreActions.search](context) {
        SwiftSpaceRepository.searchAwards()
        .then((data) => {
            context.commit(StoreMutations.SET_RESULTS, data.awards)
        })
        .catch((err) => {
            Vue.prototype.$notify({'type':'danger','content':err})
        });
    },
    [StoreActions.create](context, form) {
        SwiftSpaceRepository.createAward(form)
            .then(() => {
                context.dispatch(StoreActions.search);
            })
            .catch((err) => {
                Vue.prototype.$notify({'type':'danger','content':err})
            });
    },
    [StoreActions.update](context, form) {
        SwiftSpaceRepository.updateAward(form)
            .then(() => {
                context.dispatch(StoreActions.search);
            })
            .catch((err) => {
                Vue.prototype.$notify({'type':'danger','content':err})
            });
    },
    clearState(context) {
        context.commit(StoreMutations.SET_RESULTS,[]);
        context.commit(StoreMutations.SET_PAGE,0);
    }
};
